import { render, staticRenderFns } from "./Standby.vue?vue&type=template&id=85fc4fbc&scoped=true"
import script from "./Standby.vue?vue&type=script&lang=js"
export * from "./Standby.vue?vue&type=script&lang=js"
import style0 from "./Standby.vue?vue&type=style&index=0&id=85fc4fbc&prod&lang=scss&scoped=true"
import style1 from "./Standby.vue?vue&type=style&index=1&id=85fc4fbc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85fc4fbc",
  null
  
)

export default component.exports